<template>
  <div class="demand-warp">
    <div class="demand-title">
      {{ $t("appointment.listTitle") }}
    </div>
    <div
      v-if="isSandBox"
      class="demand-detail"
    >
      <p>
        {{ $t("appointment.demandDes") }}<b class="deco-under">{{ $t("appointment.demandDesB") }}</b>
      </p>
      <p>
        <b class="deco-under">{{ $t("appointment.demandDesSecondB") }}</b>
      </p>
    </div>
    <div class="demand-form">
      <mm-form
        :data="formData"
        :rules="formRules"
        ref="demandForm"
        layout="vertical"
      >
        <mm-form-field :label="$t('appointment.demandComponyName')">
          {{ userInfo.client.full_name }}
        </mm-form-field>
        <mm-form-field
          v-for="item in fieldList"
          :key="item.id"
          :label="item.field_name"
          :field="item.id"
          :required="String(item.require_flag) === '1'"
        >
          <template v-if="String(item.field_type) === '1'">
            <mm-input
              v-model="formData[item.id]"
              auto-trim
            />
          </template>

          <template v-else-if="String(item.field_type) === '2'">
            <mm-textarea
              resize
              v-model="formData[item.id]"
            />
          </template>

          <template v-else-if="String(item.field_type) === '3'">
            <mm-select
              v-model="formData[item.id]"
              :options="formSelectOption[item.id]"
              clearable
            />
            <mm-input
              v-if="formData[item.id] === EXT"
              v-model="formExtValue[item.id]"
              auto-trim
              style="margin-top: 10px"
            />
          </template>

          <template v-else-if="String(item.field_type) === '4'">
            <mm-date-picker
              v-model="formData[item.id]"
              type="date"
              style="width: 300px"
            />
          </template>

          <template v-else-if="String(item.field_type) === '5'">
            <mm-input
              v-model="formData[item.id]"
              type="number"
              auto-trim
            />
          </template>

          <template v-else-if="String(item.field_type) === '7'">
            <mm-select
              v-model="formData[item.id]"
              :options="
                String(item.id) === '2' ? treeData : formSelectOption[item.id]
              "
              clearable
              multiple
            />
            <mm-input
              v-if="(formData[item.id] || []).includes(EXT)"
              v-model="formExtValue[item.id]"
              auto-trim
              style="margin-top: 10px"
            />
          </template>

          <template v-else-if="String(item.field_type) === '10'">
            <mm-date-picker
              v-model="formData[item.id]"
              type="date-time"
              style="width: 300px"
            />
          </template>
        </mm-form-field>
      </mm-form>

      <mm-button
        style="margin-top: 10px"
        type="primary"
        :loading="submitButtonLoading"
        @click="handleSubmit"
      >
        {{ $t("appointment.demandNext") }}
      </mm-button>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import AppointmentApi from "@api/appointment";

const EXT = -1;

export default {
  props: {
    pageShowFn: {
      type: Function,
      default: () => ({})
    },
  },
  data() {
    return {
      // 表单数据
      formData: {},
      // 自定义表单列表数据
      fieldList: [],
      // 表单中下拉框数据
      formSelectOption: {},
      // 规则
      formRules: {},
      // 表单中 单选/多选 其他的输入信息
      formExtValue: {},
      // 公司产品的值
      treeValue: null,
      // 公司产品的数据
      treeData: null,
      EXT: EXT,
      submitButtonLoading: false,
      isSandBox: false
    };
  },
  computed: {
    ...mapState("main", {
      userInfo(state) {
        return state.userInfo;
      },
    }),
  },
  created() {
    this.fetchCategory();
    this.checkSandbox();
  },
  methods: {
    fetchInitInfo() {
      AppointmentApi.fetchAppointmentClientInfo().then((data) => {
        let fieldList = (data.list || []).filter(
          (listItem) => String(listItem.show_flag) === "1"
        );
        this.fieldList = fieldList;
        let formData = {},
          formSelectOption = {},
          formRules = {},
          formExtValue = {};
        fieldList.forEach((item) => {
          formData[item.id] = null;
          if (
            String(item.field_type) === "3" ||
            String(item.field_type) === "7"
          ) {
            let field_info = item.field_info || [];
            formSelectOption[item.id] = field_info.map((infoItem) => ({
              label: infoItem,
              value: infoItem,
            }));
            if (item.field_ext && String(item.field_ext.other) === "1") {
              formSelectOption[item.id].push({
                label: "其他",
                value: EXT,
              });
              formExtValue[item.id] = null;
            }
          }
          if (String(item.require_flag) === "1") {
            formRules[item.id] = [
              {
                required: true,
                message: `请输入${item.field_name}`,
                validator: (rule, value, callback) => {
                  if (!value || (value || []).length === 0) {
                    callback("错误");
                  }
                  callback();
                },
              },
            ];
          }
        });
        this.formRules = formRules;
        this.formData = formData;
        this.formSelectOption = formSelectOption;
        this.formExtValue = formExtValue;
      });
    },
    detailTreeData(data) {
      return data.map((item) => ({
        label: item.cn_name,
        value: item.cn_name,
      }));
    },
    fetchCategory() {
      AppointmentApi.fetchAppointmentCategoryTree().then((data) => {
        this.fetchInitInfo();
        this.treeData = this.detailTreeData(data);
      });
    },
    checkSandbox() {
      AppointmentApi.fetchCheckSandboxClient().then((data) => {
        this.isSandBox = String(data.can_open) === '1';
      })
    },
    fetchSaveForm() {
      let fieldData = [];
      for (let i = 0, len = this.fieldList.length; i < len; i++) {
        let fieldItem = this.fieldList[i];
        let field_answer = null;
        if (fieldItem.field_type === "3") {
          // 单选
          if (this.formData[fieldItem.id] === EXT) {
            field_answer = [this.formExtValue[fieldItem.id]];
          } else {
            field_answer = [this.formData[fieldItem.id]];
          }
        } else if (fieldItem.field_type === "7") {
          // 多选
          if ((this.formData[fieldItem.id] || []).includes(EXT)) {
            field_answer = this.formData[fieldItem.id].filter(
              (val) => val !== EXT
            );
            field_answer.push(this.formExtValue[fieldItem.id]);
          } else {
            field_answer = this.formData[fieldItem.id];
          }
        } else {
          field_answer = [this.formData[fieldItem.id]];
        }

        fieldData.push({
          ...fieldItem,
          field_answer: field_answer,
        });
      }
      this.submitButtonLoading = true;
      AppointmentApi.fetchAppointmentSave({ data: fieldData })
        .then(() => {
          this.pageShowFn(false, true)
        })
        .finally(() => {
          this.submitButtonLoading = false;
        });
    },
    handleSubmit() {
      this.$refs.demandForm.validate((err) => {
        if (!err) {
          // 校验其他的选项有没有填写
          let flag = true;
          let field_name = "";
          for (let i = 0, len = this.fieldList.length; i < len; i++) {
            let item = this.fieldList[i];
            if (
              (item.field_type === "3" || item.field_type === "7") &&
              (item.field_ext && String(item.field_ext.other) === "1")
            ) {
              if (item.field_type === "3") {
                if (
                  this.formData[item.id] === EXT &&
                  !this.formExtValue[item.id]
                ) {
                  flag = false;
                  field_name = item.field_name;
                  break;
                }
              } else if (item.field_type === "7") {
                if (
                  (this.formData[item.id] || []).includes(EXT) &&
                  !this.formExtValue[item.id]
                ) {
                  flag = false;
                  field_name = item.field_name;
                  break;
                }
              }
            }
          }
          if (flag) {
            // 都验证成功 下一步做数据处理
            this.fetchSaveForm();
          } else {
            this.$message.warning(
              `${field_name}的其他选项还没填写内容，请填写完成再提交`
            );
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
.demand-warp {
  color: #2a2a2a;
  padding: 60px 60px 80px;
  .demand-title {
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 15px;
    text-align: center;
  }
  .demand-detail {
    width: 700px;
    margin: 0 auto 40px;
    p:first-child {
      margin-bottom: 10px;
    }
    .deco-under {
      text-decoration: underline;
    }
  }
  .demand-form {
    width: 500px;
    margin: 0 auto;
  }
}
.mm-datepicker-popper {
  width: 300px;
}
.mm-select-dropdown--multiple {
  overflow: hidden;
}
</style>
